export const GA_EVENT_PREFIX = 'ndb';
